module.exports = __webpack_public_path__ + "static/media/order_no.26f7880c.svg";